import React from 'react';
import {
  AppDevelopment,
  CodeAuditing,
  CollaborationSupport,
  Design,
  Expert,
  MaturityDevelopment,
  Outstaffing,
  PerformanceAnalysis,
  PostDevelopmentSupport,
  ProactiveByNature,
  ResultsOverProcess,
  SecurityAudits,
  Testing,
  TransparencyOpenness,
  TrustAutonomy,
} from '../../assets/svg/index';

interface ServiceIcon {
  [key: string]: React.FC;
}

export const getServiceIcons = (): ServiceIcon => ({
  App: AppDevelopment,
  Code: CodeAuditing,
  Collaboration: CollaborationSupport,
  Design: Design,
  Expert: Expert,
  Maturity: MaturityDevelopment,
  Outstaffing: Outstaffing,
  Performance: PerformanceAnalysis,
  'Post-development': PostDevelopmentSupport,
  Proactive: ProactiveByNature,
  Results: ResultsOverProcess,
  Security: SecurityAudits,
  Testing: Testing,
  Transparency: TransparencyOpenness,
  Trust: TrustAutonomy,
  default: Design,
});
